import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const lines = [
  "Für mehr Sicherheit im Einsatz.",
  "Für mehr Vertrauen in der Organisation.",
  "Für die Menschen, denen Sie helfen.",
];

const Statement = () => (
  <section
    data-testid="statement-section"
    className="relative overflow-hidden border-y border-blau/20 bg-navy-900 py-28 sm:py-36"
  >
    <div
      aria-hidden="true"
      className="absolute left-1/2 top-1/2 h-[720px] w-[720px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[radial-gradient(circle,rgba(0,102,255,0.22)_0%,rgba(13,20,36,0)_70%)] animate-blaulicht"
    />
    <div
      aria-hidden="true"
      className="absolute -left-24 bottom-0 h-[300px] w-[300px] rounded-full bg-[radial-gradient(circle,rgba(239,68,68,0.08)_0%,rgba(13,20,36,0)_70%)]"
    />

    <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <Reveal>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.08]">
          Datenschutz muss{" "}
          <span className="text-blau text-glow-blue">kein Hindernis</span> sein.
        </h2>
        <p className="mx-auto mt-8 max-w-2xl text-base md:text-lg font-medium text-gray-300">
          Richtig verstanden schafft Datenschutz klare Zuständigkeiten, sichere
          Prozesse und Vertrauen.
        </p>
      </Reveal>

      <div className="mt-14 flex flex-col items-center gap-5">
        {lines.map((l, i) => (
          <Reveal key={l} delay={0.15 + i * 0.12}>
            <p
              data-testid={`statement-line-${i + 1}`}
              className="flex items-center gap-4 font-display text-lg sm:text-2xl font-bold text-white"
            >
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-blau text-white">
                <ArrowRight size={16} aria-hidden="true" />
              </span>
              {l}
            </p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Statement;
